module.exports = __webpack_public_path__ + "img/img.ecc858c0.png";